import Price from "@kiwicom/frontend-common/records/Price"

import type {
  AxaInsuranceAncillaries,
  AxaInsuranceAncillariesInput,
} from "../../../scenes/BookingAncillary/consts/types"

export default (
  input?: AxaInsuranceAncillariesInput,
): AxaInsuranceAncillaries | null | undefined => {
  if (!input || input.length === 0) return []

  return input.map((value) => ({
    id: value.id,
    extraId: value.extra_id,
    state: value.order_state,
    status: value.status,
    validFrom: value.valid_from,
    validTo: value.valid_to,
    items: value.items.map((pap) => ({
      id: pap.passenger_id,
      isActive: pap.is_active,
      level: pap.level,
      price: Price.fromServer(pap.price),
      universalId: pap.universal_id,
    })),
  }))
}
